import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { recordEvent } from '@/lib/analytics'

/**
 * Logs a `page_view` on every client-side navigation.
 *
 * GA4 auto-collects `page_view` on the initial document load, but a SPA
 * changes the URL without one — so without this every visit looks like a
 * single landing page and every onward journey is invisible.
 *
 * Deliberately separate from `<Seo>`, which also watches the location:
 * that one owns the document's metadata, this one owns measurement. Same
 * trigger, different jobs, and a change to either should not be able to
 * break the other.
 *
 * Renders null; mounted once inside the router in `App.tsx`.
 */
export function PageViewTracker() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    // `page_location` and `page_path` are the GA4 param names; sending them
    // explicitly stops GA4 attributing every SPA view to the entry URL.
    recordEvent('page_view', {
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
      page_search: search || undefined,
    })
  }, [pathname, search])

  return null
}
